var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showError)?_c('div',{staticClass:"alert alert-error alert-sm mt-2"},[_c('p',{staticClass:"w-full font-normal text-center"},[_vm._v(_vm._s(_vm.error[0]))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }